import React from 'react';
import { Circle, Defs, G, LinearGradient, Mask, Path, Stop, Svg, SvgProps } from 'react-native-svg';

export const AdblockCat = (props: SvgProps): JSX.Element => {
  // render
  return (
    <Svg width="94" height="93" viewBox="0 0 94 93" fill="none" {...props}>
      <Circle cx="47" cy="46.5" r="46.5" fill="#353945" />
      <Mask id="mask0_476_1340" maskUnits="userSpaceOnUse" x="0" y="0" width="94" height="93">
        <Circle cx="47" cy="46.5" r="46.5" fill="url(#paint0_linear_476_1340)" />
      </Mask>
      <G mask="url(#mask0_476_1340)">
        <Path
          d="M79.0432 123.351C93.0541 105.774 74.8599 23.5033 70.2026 17.3321C69.2497 16.0688 61.3741 23.785 59.1378 29.1563C55.618 27.8749 39.7403 27.9567 36.2498 28.9473C31.1646 22.8398 28.8311 16.4778 26.5656 17.5775C25.7781 17.9592 22.4917 25.4119 20.7221 30.3106C17.0079 40.5898 14.3146 47.1881 12.3895 54.5499C4.8444 83.3334 6.14156 117.171 17.255 125.833C30.5269 136.175 70.0282 134.603 78.6234 123.824L79.0432 123.351Z"
          fill="black"
        />
        <Path
          d="M80.4724 123.817C86.0243 116.206 85.294 104.542 84.9008 95.7135C84.2642 81.3322 83.4122 67.2578 80.4724 53.1784C78.2254 42.4017 75.735 31.4877 72.0182 21.0951C71.4096 19.3935 70.8947 16.3929 68.5541 16.7679C63.3299 17.6004 58.7143 25.3217 56.8418 29.5574C57.6657 29.3012 58.4896 29.0451 59.3135 28.7889C52.9845 26.758 44.5865 27.4807 38.0796 28.2491C37.546 28.3132 37.003 28.4047 36.488 28.5327C37.0966 28.3772 34.2036 24.0683 33.9227 23.6292C32.8273 21.9276 31.7975 20.1894 30.5991 18.5519C29.4382 16.9692 27.4814 16.4295 25.7681 17.6005C23.5305 19.1282 22.5007 23.7848 21.5738 26.0993C19.2145 31.9817 17.2484 38.047 15.1887 44.0301C11.219 55.5479 8.73798 67.5322 6.93105 79.544C5.32072 90.2659 5.52637 98.9219 6.93072 109.717C7.83887 116.679 10.8293 121.133 16.8174 126.477C23.3804 129.788 27.3138 132.403 37.7801 134.069C48.5081 134.977 53.9873 134.843 62.3759 133.388C68.7892 132.281 76.1657 129.087 80.4724 123.817C81.0903 123.058 78.4127 123.406 77.9726 123.945C74.2745 128.474 68.9192 130.107 63.4142 131.132C55.4655 132.614 47.236 132.861 39.1657 132.403C32.2469 132.01 26.3014 128.535 19.9257 125.772C14.5426 121.813 11.2749 117.411 10.0297 111.144C8.2789 102.343 7.78302 95.4348 8.70053 86.5883C9.80529 75.839 11.9399 65.1811 14.5426 54.6879C16.8832 45.256 20.3848 35.9429 23.8301 26.8586C24.5604 24.9283 25.3655 23.0163 26.1988 21.1226C26.4703 20.5188 26.7512 19.915 27.0508 19.3112C27.8747 17.6004 27.65 18.7806 26.9946 18.4055C28.5675 19.3204 29.5224 21.6806 30.4493 23.1535C31.8349 25.3674 33.2955 27.5173 34.8871 29.5939C35.1211 29.905 36.0293 29.6763 36.3101 29.6031C39.3997 28.8255 42.8825 28.981 46.047 28.9627C49.586 28.9444 53.696 28.7889 57.0946 29.8775C57.7312 30.0788 59.276 29.7861 59.5662 29.1091C61.0736 25.6784 63.4048 22.7327 65.9982 20.0156C66.4569 19.549 66.9251 19.1008 67.4213 18.6708C68.7788 17.9389 68.835 17.6919 67.5898 17.9207C67.8145 18.25 67.983 18.6251 68.1515 18.9819C69.4529 21.7264 70.2955 24.727 71.1756 27.6179C74.3775 38.166 76.8117 48.9611 78.9183 59.7653C81.2963 71.9418 81.5303 84.0219 82.1576 96.4087C82.5883 104.935 83.3466 116.544 77.9726 123.918C77.3828 124.723 80.0698 124.348 80.4724 123.79V123.817Z"
          fill="black"
        />
        <Path
          d="M23.0073 45.4369L23.5061 47.9874L25.5011 53.5984L34.4787 55.6387L40.9625 52.0681L42.4588 45.947L30.9874 44.4167L23.0073 45.4369Z"
          fill="#FCFCFC"
          stroke="black"
          strokeWidth="2.86898"
        />
        <Path
          d="M30.1143 43.8248C27.706 43.8108 21.69 43.1807 22.2547 47.3485C22.8475 51.717 25.8998 55.0168 30.7957 55.6188C35.2249 56.1602 41.437 53.6539 42.2864 49.1641C42.5618 47.7032 42.8791 45.7477 41.507 45.1129C38.8653 43.8948 35.9296 43.8575 30.1236 43.8248H30.1143ZM38.9913 49.9902C37.0264 52.7672 34.0581 53.3646 31.1738 53.1172C29.5962 52.9818 27.9254 52.3238 26.7259 51.2783C25.2371 49.9762 24.537 47.4419 24.8964 46.6018C25.2044 45.8784 27.328 46.009 28.5228 45.939C27.524 47.6986 29.2462 50.1909 31.0477 50.6482C33.6847 51.3203 36.275 48.968 36.1583 46.3264C36.2704 46.3264 36.387 46.3357 36.499 46.3404C37.8105 46.3871 39.1314 46.4664 39.6261 47.1432C40.0415 47.7126 39.8781 48.7394 38.9913 49.9902Z"
          fill="black"
        />
        <Path
          d="M52.1836 45.4369L52.6823 47.9874L54.6774 53.5984L63.655 55.6387L70.1388 52.0681L71.6351 45.947L60.1637 44.4167L52.1836 45.4369Z"
          fill="#FCFCFC"
          stroke="black"
          strokeWidth="2.86898"
        />
        <Path
          d="M68.9495 44.436C66.7092 43.6099 64.1702 43.7219 61.8226 43.7966C59.2697 43.8806 56.6094 44.0626 54.1217 44.6507C52.5115 45.0334 51.9095 45.8781 52.1615 47.5817C52.8429 52.2069 55.7366 56.0947 62.0607 55.8193C66.3125 55.6373 71.5491 52.7483 71.4511 47.5117C71.4184 45.8408 70.5457 45.0194 68.9495 44.4313V44.436ZM66.4432 52.0949C65.2017 52.9816 63.7455 53.4344 61.4259 53.5184C57.6455 53.6537 55.2559 51.1287 54.5138 48.1651C54.047 46.3075 55.8393 46.6296 57.3468 46.3729C57.6735 46.3169 58.4902 46.4382 58.4809 46.4569C57.6642 48.6085 59.447 50.368 61.6779 50.396C64.0115 50.424 65.6451 48.1977 65.1877 46.0648C66.9799 46.0928 68.5294 46.3495 68.7628 47.1943C69.1548 48.6038 67.8573 51.0774 66.4385 52.0949H66.4432Z"
          fill="black"
        />
        <Path
          d="M47.5085 61.9137V57.7157C47.5085 57.3835 46.2019 57.5346 46.2019 57.7963V61.9942C46.2019 62.3264 47.5085 62.1755 47.5085 61.9137Z"
          fill="white"
        />
        <Path
          d="M51.5651 63.9487L47.5852 61.1783C47.2703 60.959 46.5512 61.8367 46.7993 62.0094L50.7791 64.7798C51.094 64.999 51.8132 64.1214 51.5651 63.9487Z"
          fill="white"
        />
        <Path
          d="M42.12 63.7077L46.3375 61.1677C46.6713 60.9667 47.3101 61.8825 47.0472 62.0409L42.8297 64.5808C42.4959 64.7818 41.857 63.866 42.12 63.7077Z"
          fill="white"
        />
        <Path
          d="M50.0354 56.6222C49.5001 57.5536 48.1812 58.516 46.7709 58.5264C45.4781 58.5264 44.4073 57.833 43.454 56.6533C42.7228 55.7633 43.7544 55.3597 46.7186 55.339C49.5653 55.3286 50.5578 55.6908 50.0224 56.6222H50.0354Z"
          fill="white"
        />
      </G>
      <Mask id="mask1_476_1340" maskUnits="userSpaceOnUse" x="0" y="0" width="94" height="93">
        <Circle cx="47" cy="46.5" r="46.5" fill="url(#paint1_linear_476_1340)" />
      </Mask>
      <G mask="url(#mask1_476_1340)">
        <Circle cx="61.1611" cy="48.9055" r="10.4739" fill="#D9D9D9" fillOpacity="0.3" />
        <Path
          d="M61.5158 37.6836C55.1339 37.6836 49.9385 42.7989 49.9385 49.0899C49.9385 55.3809 55.1305 60.4962 61.5158 60.4962C67.9011 60.4962 73.0931 55.3809 73.0931 49.0899C73.0931 42.7989 67.9011 37.6836 61.5158 37.6836ZM51.668 49.0899C51.668 43.7327 56.0748 39.3876 61.5158 39.3876C66.9568 39.3876 71.3636 43.7292 71.3636 49.0899C71.3636 54.4506 66.9568 58.7923 61.5158 58.7923C56.0748 58.7923 51.668 54.4506 51.668 49.0899Z"
          fill="#FFAF37"
          stroke="black"
          strokeWidth="0.837283"
          strokeMiterlimit="10"
        />
        <Path
          d="M37.5272 30.223C37.5272 30.223 38.1874 25.0889 38.0853 24.2583C37.9832 23.4329 37.7041 17.5721 37.5272 17.3593C37.3502 17.1464 36.6219 14.961 37.5272 14.2134C38.4325 13.4659 55.4834 12.5886 57.1238 13.2012C58.7643 13.8137 57.1238 30.0049 57.1238 30.0049C57.1238 30.0049 50.8003 30.5033 46.0833 30.3268C41.3662 30.1503 37.5272 30.223 37.5272 30.223Z"
          fill="#A04B25"
          stroke="black"
          strokeWidth="0.837283"
          strokeMiterlimit="10"
        />
        <Path
          d="M34.4922 32.5693C39.2774 32.7095 45.6689 32.4084 49.3378 32.4084C53.0066 32.4084 59.2212 32.6472 60.4124 32.7562C61.6035 32.8652 64.0472 30.3838 60.6914 30.0672C57.3357 29.7453 54.579 30.3319 49.2016 30.3319C43.8243 30.3319 36.7316 30.2541 34.6692 30.1191C32.6067 29.9841 29.9181 32.4343 34.4922 32.5693Z"
          fill="#A04B25"
          stroke="black"
          strokeWidth="0.837283"
          strokeMiterlimit="10"
        />
        <Path
          d="M37.8536 27.5079H43.8163V30.2541L37.5269 30.2229L37.8536 27.5079Z"
          fill="#A67C52"
          stroke="black"
          strokeWidth="0.837283"
          strokeMiterlimit="10"
        />
        <Path
          d="M50.2441 27.5079H57.3572V29.9945L50.2441 30.2541V27.5079Z"
          fill="#A67C52"
          stroke="black"
          strokeWidth="0.837283"
          strokeMiterlimit="10"
        />
        <Path
          d="M34.4922 32.5693C39.2774 32.7095 45.6689 32.4084 49.3378 32.4084C53.0066 32.4084 59.2212 32.6472 60.4124 32.7562C61.6035 32.8652 64.0472 30.3838 60.6914 30.0672C57.3357 29.7453 54.579 30.3319 49.2016 30.3319C43.8243 30.3319 36.7316 30.2541 34.6692 30.1191C32.6067 29.9841 29.9181 32.4343 34.4922 32.5693Z"
          stroke="black"
          strokeWidth="0.837283"
          strokeMiterlimit="10"
        />
        <Path
          opacity="0.5"
          d="M37.5228 15.3503C37.5228 15.3503 37.8699 16.3054 37.7814 17.5202C37.6929 18.7349 38.0809 23.9987 38.1286 24.523C38.1694 25.0474 37.5228 30.4565 37.5228 30.4565C37.5228 30.4565 33.8208 29.9844 33.4805 30.5762C31.609 30.5762 31.595 32.4759 33.1061 32.4759C34.6172 32.4759 46.6234 32.4759 48.7743 32.4759C50.9253 32.4759 56.8336 32.8133 57.6163 32.8497C58.3923 32.886 59.3044 30.6434 58.263 30.1762C55.9282 30.3735 52.3071 30.3371 52.1777 30.3371C52.0484 30.3371 51.9599 26.8175 52.0076 26.1946C52.0552 25.5717 52.3071 24.2168 52.5657 23.0539C52.8244 21.8911 53.5595 18.7661 53.5595 18.0445C53.5595 17.3229 53.3961 15.9732 52.9401 15.6773C52.484 15.3814 52.6066 15.016 52.0076 14.8187C51.4086 14.6214 51.7013 14.5301 49.5503 14.364C47.3994 14.1978 45.5752 14.2965 45.0442 14.3328C44.5133 14.3691 42.6142 14.4314 41.6272 14.5301C40.6335 14.6287 37.4002 14.8519 37.5296 15.3503H37.5228Z"
          fill="black"
        />
        <Path
          d="M43.8176 30.2541V27.0304L50.2432 26.8695V30.2541H43.8176Z"
          fill="#F7931E"
          stroke="black"
          strokeWidth="0.837283"
          strokeMiterlimit="10"
        />
        <Path
          d="M46.1004 61.7538C44.9895 59.641 42.3369 59.6514 40.603 61.4112C38.8017 63.2384 37.8725 64.8114 34.2283 64.4687C35.5416 67.2979 40.1254 64.8114 40.1254 64.8114L39.6063 65.8859L42.2538 64.8114L41.7503 65.8859C41.7503 65.8859 47.6734 64.7439 46.1004 61.7538Z"
          fill="#8C6239"
          stroke="black"
          strokeWidth="0.837283"
          strokeMiterlimit="10"
        />
        <Path
          d="M46.952 61.7538C48.0629 59.641 50.7156 59.6514 52.4495 61.4112C54.2508 63.2384 55.18 64.8114 58.8242 64.4687C57.5108 67.2979 52.9271 64.8114 52.9271 64.8114L53.4462 65.8859L50.7987 64.8114L51.3022 65.8859C51.3022 65.8859 45.3791 64.7439 46.952 61.7538Z"
          fill="#8C6239"
          stroke="black"
          strokeWidth="0.837283"
          strokeMiterlimit="10"
        />
        <Path
          d="M75.844 67.9751L75.8186 68.3943L75.844 67.9751ZM83.3872 64.1476C83.3393 63.9206 83.1164 63.7755 82.8895 63.8234C82.6625 63.8714 82.5174 64.0942 82.5653 64.3212L83.3872 64.1476ZM66.6051 58.1428C67.4151 60.3814 68.4301 62.8512 69.8714 64.8021C71.318 66.7602 73.2264 68.2369 75.8186 68.3943L75.8695 67.5558C73.6108 67.4187 71.9055 66.1418 70.547 64.303C69.1831 62.4569 68.2016 60.0864 67.3949 57.857L66.6051 58.1428ZM75.8186 68.3943C78.4627 68.5548 80.4134 67.9415 81.68 67.0748C82.3117 66.6425 82.7775 66.1439 83.0677 65.6432C83.3542 65.1489 83.4869 64.6197 83.3872 64.1476L82.5653 64.3212C82.6083 64.5245 82.5627 64.8395 82.341 65.2219C82.123 65.598 81.7508 66.0085 81.2057 66.3815C80.1186 67.1254 78.3606 67.707 75.8695 67.5558L75.8186 68.3943Z"
          fill="#FFAF37"
        />
      </G>
      <Defs>
        <linearGradient
          id="paint0_linear_476_1340"
          x1="93.5"
          y1="-4.92601e-06"
          x2="10.8553"
          y2="69.1276"
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#FFEBA2" />
          <Stop offset="1" stopColor="#FF8669" />
        </linearGradient>
        <LinearGradient
          id="paint1_linear_476_1340"
          x1="93.5"
          y1="-4.92601e-06"
          x2="10.8553"
          y2="69.1276"
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#FFEBA2" />
          <Stop offset="1" stopColor="#FF8669" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
};
